import { deleteMasterRoom, getRoom, getRoomFloor } from "_services";
import {
  ButtonHeading,
  CommonModal,
  CommonPagination,
  CustomPagination,
} from "components";
import BootstrapTable from "components/BootstrapTable";
import { AddBulkRoom, AddRoomModal } from "modals";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import { UserContext } from "context";

const Room = () => {
  const { masterData } = useContext(UserContext);
  const navigate = useNavigate();
  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showBulkRoom, setShowBulkRoom] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [allRoomlist, setAllRoomList] = useState([]);
  const [eventView, setEventView] = useState(false);
  const [addressId, setAddressId] = useState("");

  const [filter, setFilter] = useState({
    limit: 10,
    offset: 1,
    search: "",
    status: 1,
  });

  const itemsPerPage = 10;
  const [totalItems, setTotalItems] = useState(0);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);

  const columns = [
    { header: "Floor Nmae", accessor: "floor_name" },
    { header: "Room Number", accessor: "room_number" },
    { header: "", accessor: "action" },

    // { header: "Status", accessor: "status" },
  ];

  useEffect(() => {
    getRoomList();
  }, []);

  const getRoomList = async (url = null) => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart();
      }
      const res = await getRoomFloor(url);

      if (res?.status === 200) {
        setAllRoomList(res?.results);
        setNextPageUrl(res?.next);
        setPrevPageUrl(res?.previous);
        setTotalItems(res?.count);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };

  const deleteHandler = (item) => {
    setIsDelete(item);
  };

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                onClick={() => {
                  setEventView(item?.id);
                  setAddressId(item?.id);
                  setShowOffcanvas(true);
                }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>
              <Link
                onClick={() => {
                  setAddressId(item?.id);
                  setShowOffcanvas(true);
                }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>
              

              <div onClick={(e) => deleteHandler(item)} className="_avPointer">
                <span className="_samAnchor">
                  <span className="deleteIcon_avt">
                    <FaRegTrashCan color="red" />
                  </span>
                  Delete
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),

      // zoneName: zoneList?.find((i) => i?._id === item?.zone_id)?.name || "",
      supplier_name: (
        <Link style={{ textDecoration: "none" }}>
          {item?.company_user_name ? item?.company_user_name : "-"}
        </Link>
      ),
      contact_number: (
        <React.Fragment>
          {item?.user_id?.mobile_no ? item?.user_id?.mobile_no : "-"}
        </React.Fragment>
      ),
      category: (
        <React.Fragment>
          {
            masterData?.addressbook_category_list.find(
              (fx) => fx?.id == item?.category
            )?.name
          }
        </React.Fragment>
      ),
      party_group: (
        <React.Fragment>
          {item?.consignor_group_id?.name
            ? item?.consignor_group_id?.name
            : "-"}
        </React.Fragment>
      ),
      city: (
        <React.Fragment>
          {item?.city?.label ? item?.city?.label : "-"}
        </React.Fragment>
      ),
      status: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={item?.active}
            // onChange={() => handleStatusEvent(item, i)}
          />
          <span
            className={
              item?.active
                ? "active_label_masters_status"
                : "disabled_label_masters_status"
            }
          >
            {item?.active ? "Active" : "Disabled"}
          </span>
        </div>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <span
            className="viewIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEventView(item?.id);
              setAddressId(item?.id);
              setShowOffcanvas(true);
            }}
          >
            <AiOutlineEye color="green" />
          </span>
          <span
            className="viewIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setAddressId(item?.id);
              setShowOffcanvas(true);
            }}
          >
            <FiEdit color="blue" />
          </span>
          <span
            className="deleteIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={(e) => deleteHandler(item)}
          >
            <FaRegTrashCan color="red" />
          </span>
        </div>
      ),
      balance: item?.balance ? (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color:
                item.balance < 0
                  ? "#dc3545"
                  : item.balance > 0
                  ? "#28a745"
                  : "#1450ec",
            }}
          >
            <span></span>
            <span>{item.balance}</span>
          </div>
        </Link>
      ) : (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color: "#1450ec",
            }}
          >
            <span></span>
            <span>0</span>
          </div>
        </Link>
      ),
    }));
  };

  const callback = () => {
    setEventView(false);
    getRoomList();
    setAddressId("");
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  const submitDeleteSupplier = async () => {
    setLoading(true);
    try {
      loadingBarRef.current?.continuousStart();
      let object = {
        id: isDelete?.id,
      };

      const res = await deleteMasterRoom(object);
      if (res?.status == 200) {
        toast.success(`${res?.message}`);
        getRoomList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleNextPage = () => {
    if (nextPageUrl) {
      getRoomList(nextPageUrl);
    }
  };

  const handlePrevPage = () => {
    if (prevPageUrl) {
      getRoomList(prevPageUrl);
    }
  };

  const callBackNext = () => {
    handleNextPage();
  };

  const callBackPre = () => {
    handlePrevPage();
  };

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteSupplier,
    isLoadding: loading,
  };

  let bulkProps = {
    isOpen: showBulkRoom,
    closeModal: (e) => {
      setEventView(false);
      setAddressId("");
      setShowBulkRoom(false);
    },
    modalMainClass: "_dashCommon_Modal _smModal",
    loading: loading,
    modalTitle: addressId
      ? eventView
        ? "View Room"
        : "Update Room"
      : "Add Room",
    submitTitle: addressId ? (eventView ? "Room" : "Update Room") : "Add Room",
    callback: callback,
    addressId: addressId,
    eventView: eventView,
  };

  let eventProps = {
    isOpen: showOffcanvas,
    closeModal: (e) => {
      setEventView(false);
      setAddressId("");
      setShowOffcanvas(false);
    },
    modalMainClass: "_dashCommon_Modal _smModal",
    loading: loading,
    modalTitle: addressId
      ? eventView
        ? "View Room"
        : "Update Room"
      : "Add Room",
    submitTitle: addressId ? (eventView ? "Room" : "Update Room") : "Add Room",
    callback: callback,
    addressId: addressId,
    eventView: eventView,
  };

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <ButtonHeading
        title={"Room"}
        // onClick={() => setShowOffcanvas(true)}
        // onClickSecond={()=>setShowBulkRoom(true)}
        // buttonTitle={"Add Room"}
        // buttonSecondTitle={"Add Bulk Room"}
        showSearchFilter={{
          search: false,
          filterOption: false,
          filterCount: true,
        }}
        onClickFilterModal={(e) => setShowFilterModal(false)}
        filter={filter}
        setFilter={setFilter}
      />

      <div className="_tabWith_outTab">
        <div className="accordion _fuelCard_acc " id="quickUploadAccordion">
          {allRoomlist?.map((account, index) => {
            return (
              <div className="accordion-item" key={account.id}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${
                      index === 0 ? "" : "collapsed"
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={`collapse${index}`}
                  >
                    <div className="_msxFlx">
                      <p>{account.floor_name}</p>
                      <span>{account?.rooms?.length}</span>
                    </div>
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${
                    index === 0 ? "show" : ""
                  }`}
                  data-bs-parent="#quickUploadAccordion"
                >
                  <div className="accordion-body">
                    <table className="_trpTable_xd">
                      {account?.rooms?.map((item) => {
                        return (
                          <tbody>
                            <tr>
                              <td>
                                <div>
                                  <span>Room Number</span>
                                </div>
                              </td>

                              <td>
                                <div>
                                  <span>{item?.room_number}</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })}
                    </table>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* { allRoomlist?.length > 0 && <div className="paginationFt_avt "> <CommonPagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          handleNextPage={callBackNext}
          handlePrevPage={callBackPre}
        /></div>} */}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isDelete?.id && (
        <CommonModal {...propsObject}>
          <p className="p-3">
            {" "}
            Do you really want to delete {isDelete?.room_number}{" "}
          </p>
        </CommonModal>
      )}

      {showOffcanvas && <AddRoomModal {...eventProps} />}
      {showBulkRoom && <AddBulkRoom {...bulkProps} />}
    </div>
  );
};

export default Room;
